import { render } from "./z-inbox.svg.js?vue&type=template&id=3138928a!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??clonedRuleSet-12.use[0]!../../../../../node_modules/vue-svg-loader-2/index.js??clonedRuleSet-12.use[1]!./z-inbox.svg?vue&type=template&id=3138928a"
const script = {  }

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__